define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AnimationController = require("shared/ui/experience/widgets/animations/AnimationController");
    const Preconditions       = require("shared/util/Preconditions");

    /**
     * The animation controller for a slide animation.
     *
     * @class SlideAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.INTRO, // We're sliding in, hence "intro"

        descriptor() {
            const appearanceDescriptor = this.getAppearanceDescriptor();
            const scaledExperienceSize = this.unscaledExperienceSize.scale(appearanceDescriptor.scale);
            const stylingRect = appearanceDescriptor.styling;

            // Let's calculate "from" coordinates
            const fromPoint = appearanceDescriptor.position;
            const toPoint = _.clone(fromPoint);
            const direction = this.animationModel.get("direction");

            switch (direction) {
                case "top":
                    fromPoint.y = -this.elementBounds.height - appearanceDescriptor.positionOffset.y - Math.max(0, stylingRect.height + stylingRect.y);
                    break;

                case "left":
                    fromPoint.x = -this.elementBounds.width - appearanceDescriptor.positionOffset.x - Math.max(0, stylingRect.width + stylingRect.x)
                        - Math.ceil((this.elementRect.width - this.elementBounds.width) / 2);
                    break;

                case "bottom":
                    fromPoint.y = (scaledExperienceSize.height - appearanceDescriptor.positionOffset.y) + appearanceDescriptor.pivotOffset.height + Math.max(0, stylingRect.height - stylingRect.y);
                    break;

                case "right":
                    fromPoint.x = ((scaledExperienceSize.width - appearanceDescriptor.positionOffset.x) + Math.max(0, stylingRect.width - stylingRect.x))
                        - Math.ceil((this.elementRect.width - this.elementBounds.width) / 2);
                    break;
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn(`DefaultSwitchWarn - Direction '${direction}' not recognized.`);
                    break;
            }

            return {
                fromTo: [fromPoint, toPoint]
            };
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/slide/SlideAnimationController.js